export interface OfferAuditRecord {
    createdAt: Date;
    type: OfferAuditRecordType;
    extras: any;
}


export enum OfferAuditRecordType {
    Visited = 'visited',
    Accepted = 'accepted',
    Comment = 'comment',
}
